export const hotelCarousel = [
  {
    ctaProperties: {
      ctaType: 'primaryButton',
      linkUrl: 'https://www.uat02.luxury.marriott.com/about-us',
      linkText: 'Explore This Suite',
      linkType: 'internal',
      openInANewTab: true,
    },
    dynamicImage: {
      altText: 'rdtg',
      assetPath: 'https://cache.marriott.com/is/image/marriotts7stage/xr-mlexr-69790',
      enableSmartCrop: true,
      dynamic: true,
      renditions: [
        {
          renditionPath:
            'https://cache.marriott.com/is/image/marriotts7stage/xr-mlexr-69790:Classic-Hor?wid=650&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/xr-mlexr-69790:Classic-Hor?wid=1300&fit=constrain 2x',
          mediaValue: '1200px',
          width: 0,
          dynamic: true,
          smartCropType: null,
          damPath: '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-69790.tif',
          mediaQuery: 'min-width',
          height: 0,
        },
        {
          renditionPath:
            'https://cache.marriott.com/is/image/marriotts7stage/xr-mlexr-69790:Classic-Hor?wid=464&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/xr-mlexr-69790:Classic-Hor?wid=928&fit=constrain 2x',
          mediaValue: '768px',
          width: 0,
          dynamic: true,
          smartCropType: null,
          damPath: '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-69790.tif',
          mediaQuery: 'min-width',
          height: 0,
        },
        {
          renditionPath:
            'https://cache.marriott.com/is/image/marriotts7stage/xr-mlexr-69790:Classic-Hor?wid=336&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/xr-mlexr-69790:Classic-Hor?wid=672&fit=constrain 2x',
          mediaValue: '767px',
          width: 0,
          dynamic: true,
          smartCropType: null,
          damPath: '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-69790.tif',
          mediaQuery: 'max-width',
          height: 0,
        },
      ],
      damPath: '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-69790.tif',
    },
    altText: 'rdtg',
    imagePath: '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-69790.tif',
    name: 'Signature Feature Hotel test test',
    description:
      '<p>The ground-floor Family Cortes Beachfront Suite features outdoor terraces with individual plunge pools.</p>\r\n',
    tabIndex: '1',
    eyebrowText: 'Highlights and Features',
    clickTrackValue: 'Signature Feature Hotel test test|Explore This Suite|internal',
  },
  {
    ctaProperties: {
      ctaType: 'primaryButton',
      linkUrl: 'https://www.uat02.luxury.marriott.com/about-us/editorial',
      linkText: 'Explore This Suite',
      linkType: 'internal',
      openInANewTab: true,
    },
    dynamicImage: {
      altText: 'Beach_Bar_Model_St_Regis_Maldives ',
      assetPath: 'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-beach-bar-41171',
      enableSmartCrop: true,
      dynamic: true,
      renditions: [
        {
          renditionPath:
            'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-beach-bar-41171:Classic-Hor?wid=650&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-beach-bar-41171:Classic-Hor?wid=1300&fit=constrain 2x',
          mediaValue: '1200px',
          width: 0,
          dynamic: true,
          smartCropType: null,
          damPath:
            '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-beach-bar-41171.tif',
          mediaQuery: 'min-width',
          height: 0,
        },
        {
          renditionPath:
            'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-beach-bar-41171:Classic-Hor?wid=464&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-beach-bar-41171:Classic-Hor?wid=928&fit=constrain 2x',
          mediaValue: '768px',
          width: 0,
          dynamic: true,
          smartCropType: null,
          damPath:
            '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-beach-bar-41171.tif',
          mediaQuery: 'min-width',
          height: 0,
        },
        {
          renditionPath:
            'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-beach-bar-41171:Classic-Hor?wid=336&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-beach-bar-41171:Classic-Hor?wid=672&fit=constrain 2x',
          mediaValue: '767px',
          width: 0,
          dynamic: true,
          smartCropType: null,
          damPath:
            '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-beach-bar-41171.tif',
          mediaQuery: 'max-width',
          height: 0,
        },
      ],
      damPath:
        '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-beach-bar-41171.tif',
    },
    altText: 'Beach_Bar_Model_St_Regis_Maldives ',
    imagePath:
      '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-beach-bar-41171.tif',
    name: 'Signature Feature Hotel',
    description:
      '<p>The ground-floor Family Cortes Beachfront Suite features outdoor terraces with individual plunge pools.</p>\r\n',
    tabIndex: '2',
    eyebrowText: 'Highlights and Features',
    clickTrackValue: 'Signature Feature Hotel|Explore This Suite|internal',
  },
  {
    ctaProperties: {
      ctaType: 'primaryButton',
      linkUrl: 'https://www.uat02.luxury.marriott.com/about-us/top-nav-cinemograph/cinemograph-image-var',
      linkText: 'Explore This Suite',
      linkType: 'internal',
      openInANewTab: true,
    },
    dynamicImage: {
      altText: 'Beachside dining at Crust & Craft',
      assetPath: 'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-crust-and-craft-36495-69245',
      enableSmartCrop: true,
      dynamic: true,
      renditions: [
        {
          renditionPath:
            'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-crust-and-craft-36495-69245:Classic-Hor?wid=650&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-crust-and-craft-36495-69245:Classic-Hor?wid=1300&fit=constrain 2x',
          mediaValue: '1200px',
          width: 0,
          dynamic: true,
          smartCropType: null,
          damPath:
            '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-crust-and-craft-36495-69245.tif',
          mediaQuery: 'min-width',
          height: 0,
        },
        {
          renditionPath:
            'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-crust-and-craft-36495-69245:Classic-Hor?wid=464&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-crust-and-craft-36495-69245:Classic-Hor?wid=928&fit=constrain 2x',
          mediaValue: '768px',
          width: 0,
          dynamic: true,
          smartCropType: null,
          damPath:
            '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-crust-and-craft-36495-69245.tif',
          mediaQuery: 'min-width',
          height: 0,
        },
        {
          renditionPath:
            'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-crust-and-craft-36495-69245:Classic-Hor?wid=336&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-crust-and-craft-36495-69245:Classic-Hor?wid=672&fit=constrain 2x',
          mediaValue: '767px',
          width: 0,
          dynamic: true,
          smartCropType: null,
          damPath:
            '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-crust-and-craft-36495-69245.tif',
          mediaQuery: 'max-width',
          height: 0,
        },
      ],
      damPath:
        '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-crust-and-craft-36495-69245.tif',
    },
    altText: 'Beachside dining at Crust & Craft',
    imagePath:
      '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-crust-and-craft-36495-69245.tif',
    name: 'Signature Feature Hotel',
    description:
      '<p>The ground-floor Family Cortes Beachfront Suite features outdoor terraces with individual plunge pools.</p>\r\n',
    tabIndex: '3',
    eyebrowText: 'Highlights and Features',
    clickTrackValue: 'Signature Feature Hotel|Explore This Suite|internal',
  },
  {
    ctaProperties: {
      ctaType: 'primaryButton',
      linkUrl: 'https://luxurygrouphotels.com/',
      linkText: 'Explore This Suite',
      linkType: 'external',
      openInANewTab: true,
    },
    dynamicImage: {
      altText: 'Beach Wedding and Event Venues',
      assetPath: 'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-beach-wedding-setup-21671',
      enableSmartCrop: true,
      dynamic: true,
      renditions: [
        {
          renditionPath:
            'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-beach-wedding-setup-21671:Classic-Hor?wid=650&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-beach-wedding-setup-21671:Classic-Hor?wid=1300&fit=constrain 2x',
          mediaValue: '1200px',
          width: 0,
          dynamic: true,
          smartCropType: null,
          damPath:
            '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-beach-wedding-setup-21671.tif',
          mediaQuery: 'min-width',
          height: 0,
        },
        {
          renditionPath:
            'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-beach-wedding-setup-21671:Classic-Hor?wid=464&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-beach-wedding-setup-21671:Classic-Hor?wid=928&fit=constrain 2x',
          mediaValue: '768px',
          width: 0,
          dynamic: true,
          smartCropType: null,
          damPath:
            '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-beach-wedding-setup-21671.tif',
          mediaQuery: 'min-width',
          height: 0,
        },
        {
          renditionPath:
            'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-beach-wedding-setup-21671:Classic-Hor?wid=336&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-beach-wedding-setup-21671:Classic-Hor?wid=672&fit=constrain 2x',
          mediaValue: '767px',
          width: 0,
          dynamic: true,
          smartCropType: null,
          damPath:
            '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-beach-wedding-setup-21671.tif',
          mediaQuery: 'max-width',
          height: 0,
        },
      ],
      damPath:
        '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-beach-wedding-setup-21671.tif',
    },
    altText: 'Beach Wedding and Event Venues',
    imagePath:
      '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-beach-wedding-setup-21671.tif',
    name: 'Signature Feature Hotel',
    description:
      '<p>The ground-floor Family Cortes Beachfront Suite features outdoor terraces with individual plunge pools.</p>\r\n',
    tabIndex: '4',
    eyebrowText: 'Highlights and Features',
    clickTrackValue: 'Signature Feature Hotel|Explore This Suite|external',
  },
  {
    ctaProperties: {
      ctaType: 'primaryButton',
      linkUrl: 'https://luxurygrouphotels.com/',
      linkText: 'Explore This Suite',
      linkType: 'external',
      openInANewTab: false,
    },
    dynamicImage: {
      altText: 'Vommuli Island',
      assetPath: 'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-vommuli-island-96623',
      enableSmartCrop: true,
      dynamic: true,
      renditions: [
        {
          renditionPath:
            'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-vommuli-island-96623:Classic-Hor?wid=650&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-vommuli-island-96623:Classic-Hor?wid=1300&fit=constrain 2x',
          mediaValue: '1200px',
          width: 0,
          dynamic: true,
          smartCropType: null,
          damPath:
            '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-vommuli-island-96623.jpg',
          mediaQuery: 'min-width',
          height: 0,
        },
        {
          renditionPath:
            'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-vommuli-island-96623:Classic-Hor?wid=464&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-vommuli-island-96623:Classic-Hor?wid=928&fit=constrain 2x',
          mediaValue: '768px',
          width: 0,
          dynamic: true,
          smartCropType: null,
          damPath:
            '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-vommuli-island-96623.jpg',
          mediaQuery: 'min-width',
          height: 0,
        },
        {
          renditionPath:
            'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-vommuli-island-96623:Classic-Hor?wid=336&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-vommuli-island-96623:Classic-Hor?wid=672&fit=constrain 2x',
          mediaValue: '767px',
          width: 0,
          dynamic: true,
          smartCropType: null,
          damPath:
            '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-vommuli-island-96623.jpg',
          mediaQuery: 'max-width',
          height: 0,
        },
      ],
      damPath:
        '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-vommuli-island-96623.jpg',
    },
    altText: 'Vommuli Island',
    imagePath:
      '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-vommuli-island-96623.jpg',
    name: 'Signature Feature Hotel',
    description:
      '<p>The ground-floor Family Cortes Beachfront Suite features outdoor terraces with individual plunge pools.</p>\r\n',
    tabIndex: '5',
    eyebrowText: 'Highlights and Features',
    clickTrackValue: 'Signature Feature Hotel|Explore This Suite|external',
  },
];
